import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'

import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'

import { Box, Button, Columns } from '@domain-group/suit-theme'

import PageHeader from '@components/PageHeader'

import useSystemManagerNestedNavigation from '@hooks/useSystemManagerNestedNavigation'

import generateTabBarItems from '../../utils/generateTabBarItems'

const PageLayout = (props) => {
  const { activeTabBarItemKey, children, entityPayload } = props

  const {
    publication,
    urls: {
      publicationsIndexUrl,
    },
  } = entityPayload

  const { redirect } = parsePermittedQueryParams(getQueryParamsFromHash(), ['redirect'])

  const { shouldUseNestedNavigation } = useSystemManagerNestedNavigation()

  return (
    <>
      <Helmet>
        <title>Publication | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button
            as="a"
            buttonStyle="secondaryUtility"
            href={redirect || publicationsIndexUrl}
            size="medium"
            width="auto"
          >
            Back
          </Button>
        )}
        activeTabBarItemKey={activeTabBarItemKey || 'details'}
        nestedNavigation={shouldUseNestedNavigation}
        tabBarItems={generateTabBarItems(publication)}
        title="Edit Publication"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          {children}
        </Columns>
      </Box>
    </>
  )
}

PageLayout.propTypes = {
  activeTabBarItemKey: PropTypes.string,
  children: PropTypes.node.isRequired,
  entityPayload: PropTypes.shape({
    publication: PropTypes.object.isRequired,
    urls: PropTypes.shape({
      publicationsIndexUrl: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}

export default PageLayout
